module.exports = __webpack_public_path__ + "shopping_black.b3f1da70.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/media/landing/black/shopping_black.png
// module id = 937
// module chunks = 0